import React from 'react';

function DefaultOutletLayout({children}) {

    return (
        <div className="grow" style={{backgroundColor:'#f0f0f0', minHeight: '100%'}}>
            <div className="m-15 d-col gap-15">
                {children}
            </div>
        </div>
    );
}

export default DefaultOutletLayout;